export const MESSAGE_BOX_DISMISSED = '@@toyota/MESSAGE_DISMISSED';
export const MESSAGE_BOX_ERROR_ADDED = '@@toyota/ERROR_ADDED';
export const MESSAGE_BOX_WARNING_ADDED = '@@toyota/WARNING_ADDED';
export const MESSAGE_BOX_INFO_ADDED = '@@toyota/INFO_ADDED';
export const MESSAGE_BOX_CUSTOM = '@@toyota/BOX_CUSTOM';

